<template>
    <UIcon v-if="icon && checkProvider === 'iconify'" :name="icon" :class="twMerge('w-8 h-8', className)" dynamic />
    <UiIconSvgs v-else-if="icon && checkProvider === 'assets'" :name="(icon as ISvgList)" :class-name="className" />
</template>

<script lang="ts" setup>
import { twMerge } from "tailwind-merge";
import svgs from "~/assets/svg/coffee-assets";
import type { ISvgList } from "~/libs/types/general";

type ProviderType = "iconify" | "assets";

const props = defineProps({
    icon: String as PropType<string | ISvgList>,
    provider: String as PropType<ProviderType>,
    className: String,
});

const checkProvider: ComputedRef<ProviderType> = computed(() => {
    if (props.provider) return props.provider;
    if (props.icon && Object.keys(svgs).includes(props.icon)) return "assets";
    return "iconify";
});
</script>

<style></style>
